import { ChangeDetectorRef, Component, Input, OnInit } from "@angular/core";

import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslationService } from "../../../_services/translation.service";
import { Observable } from "rxjs/Observable";
import { ITranslations } from "../../../_models/ITranslations";
import { CheckPaymentItem } from "../receipt-page-models/CheckPaymentItem";
import { Epoc } from "../../../_models/Epoc";
import { DateAndTimeUtils } from "../../../_helpers/dateUtils";

@Component({
  selector: "receipt-page-submit-receipt-modal-display-checks",
  templateUrl:
    "./receipt-page-submit-receipt-modal-display-checks.component.html",
  styleUrls: [
    "./receipt-page-submit-receipt-modal-display-checks.component.scss",
  ],
})
export class ReceiptPageSubmitReceiptModalDisplayChecksComponent
  implements OnInit
{
  public translations$: Observable<ITranslations>;
  public checksItems: CheckPaymentItem[];

  constructor(
    private modalService: NgbModal,
    public activeModal: NgbActiveModal,
    private changeDetector: ChangeDetectorRef,
    private translationService: TranslationService
  ) {
    this.translations$ = this.translationService.translations;
  }

  @Input("checksPaymentItems") public set checksPaymentItems(
    value: CheckPaymentItem[]
  ) {
    this.checksItems = value;
  }
  public stringFromEpoc(epoc: Epoc | number) {
    const date = DateAndTimeUtils.serverEpochToDate(epoc as Epoc);
    return this.formatDate(date);
  }

  public formatDate(date: Date) {
    return `${date.getDate()}.${date.getMonth() + 1}.${
      date.getFullYear() - 2000
    }`;
  }
  public ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/app/admin/receipt/receipt-page-submit-receipt-modal-display-checks/receipt-page-submit-receipt-modal-display-checks.component.ts